module.exports = __webpack_public_path__ + "static/platform-2f1d4b713bf4d7b210bf34c9420a6716.png";